/* NIPLUX action icons. Presentation only: URLs, submissions and cart handlers are preserved. */
(() => {
  'use strict';
  const paths = {
    external: '<path d="M6 18 18 6M6 6h12v12"/>',
    down: '<path d="m6 9 6 6 6-6"/>', up: '<path d="m6 15 6-6 6 6"/>',
    right: '<path d="m9 6 6 6-6 6"/>', left: '<path d="m15 6-6 6 6 6"/>',
    mail: '<rect x="3" y="5" width="18" height="14"/><path d="m3 6 9 7 9-7"/>',
    cart: '<path d="M3 3h2l2.4 12h11.2l2-8H6"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/>'
  };
  const links = 'a.np-resource-action,a[class*="button"],a[class*="__btn"],a[class$="-btn"],a.btn,a.np-button,a.product-support__button,a.np-series-more,a.np-series-scroll,a.common-footer-btn,a[class*="common-footer-btn-"],a.news-btn,a.brand-concept__btn,a.igari-button,.np-care>a,.np-alert,.np-lineup article>a,.np-series-product a,.np-topics-more a,.np-purchase__support a,.np-purchase__resource-links a,.np-purchase__resources-title,.nls-card[href],.nm-btn,.nm-cover-register,.nm-nav a,.nf-categories a,.nf-contact-actions a,.nf-top a';
  function svg(type) {
    const el = document.createElementNS('http://www.w3.org/2000/svg','svg');
    for (const [key,value] of Object.entries({class:'np-action-icon np-action-icon--'+type,viewBox:'0 0 24 24',fill:'none',stroke:'currentColor','stroke-width':'1.5','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'})) el.setAttribute(key,value);
    el.innerHTML=paths[type]; return el;
  }
  function apply(el,type,host=el) {
    const old=host.querySelector('.np-action-icon');
    const reuse = old && old.classList.contains('np-action-icon--'+type);
    host.querySelectorAll('.np-action-icon').forEach(n => { if(n !== old || !reuse) n.remove(); });
    // Replace decorative CTA icons; product images and functional cart icons are preserved.
    host.querySelectorAll('.support-icon-svg,.icon-arrow-left,.icon-arrow-right,.icon-chevron-down,.icon-chevron-up,.icon-mail,.icon-email').forEach(n=>n.remove());
    host.querySelectorAll('.np-purchase__chevron').forEach(n=>n.remove());
    host.querySelectorAll('i,span').forEach(n=>{if(!n.children.length && /^[\s→↗↓←↑›»‹«＞＜⌄⌃]+$/.test(n.textContent))n.remove();});
    const walker=document.createTreeWalker(host,NodeFilter.SHOW_TEXT);
    const texts=[];while(walker.nextNode())texts.push(walker.currentNode);
    texts.forEach(n=>{if(!n.parentElement.closest('svg,script,style')) n.nodeValue=n.nodeValue.replace(/[→↗↓←↑›»‹«＞＜⌄⌃]/g,'');});
    if(!host.querySelector('img,picture'))host.querySelectorAll('svg:not(.placeholder-svg):not(.np-action-icon)').forEach(n=>n.remove());
    if (!reuse) host.append(svg(type));
  }
  function clearAccordionIcon(el) {
    el.querySelectorAll('.np-lp-support__plus,.faq__icon-wrapper,.collapsible-trigger__icon').forEach(n=>n.remove());
    el.querySelectorAll('span[aria-hidden="true"],i[aria-hidden="true"]').forEach(n=>{
      if(!n.children.length && /^[\s+＋−–—-]+$/.test(n.textContent))n.remove();
    });
  }
  function update() {
    // HTML supplied by product metafields is rendered after the theme's templates.
    document.querySelectorAll('.product-single__meta a,.product-block a,.rte a').forEach(el=>{
      if(!/^(商品へのお問い合わせ|返品[・･]?交換について|取扱説明書を見る|商品について詳しく)/.test(el.textContent.trim()))return;
      if(!el.matches(links)){el.classList.add('np-resource-action');}
    });

    document.querySelectorAll(links).forEach(el=>{
      if(!el.textContent.trim() || el.matches('[data-add-to-cart],.js-drawer-open-cart') || el.querySelector('.icon-cart'))return;
      const raw=el.getAttribute('href');if(!raw || raw==='#')return;
      let url;try{url=new URL(raw,location.href);}catch{return;}
      if(!['http:','https:','mailto:','tel:'].includes(url.protocol))return;
      if (el.querySelector('.btn-icon--left')) el.dataset.npLegacyDirection='left';
      let type='right';
      if(url.protocol==='tel:')return;
      if(url.protocol==='mailto:' || /お問い合わせ|問い合わせ/.test(el.textContent))type='mail';
      else if(el.classList.contains('return-link') || el.dataset.npLegacyDirection==='left' || /^(?:[‹«←＜]\s*)?(?:TOP|トップ|一覧|前のページ).*(?:戻る|もどる)/i.test(el.textContent.trim()))type='left';
      else if(url.origin!==location.origin || el.target==='_blank' || /\.pdf$/i.test(url.pathname))type='external';
      else if(url.pathname===location.pathname && url.search===location.search && url.hash){
        let target;try{target=document.getElementById(decodeURIComponent(url.hash.slice(1)));}catch{}
        type=target && target.getBoundingClientRect().top<el.getBoundingClientRect().top?'up':'down';
      }else if(el.classList.contains('return-link'))type='left';
      const host=el.querySelector('.np-series-product-cta') || (el.closest('.np-lineup') ? el.querySelector('span:last-child') : null) || el;
      apply(el,type,host);
      if(!el.querySelector('img,picture') && !el.classList.contains('np-series-scroll'))el.classList.add('np-action-link');
    });
    document.querySelectorAll('details>summary').forEach(el=>{
      if(el.closest('.np-header,.site-header,.np-mobile-drawer') || !el.textContent.trim())return;
      clearAccordionIcon(el);
      el.classList.add('np-action-summary');apply(el,'down');
    });
    document.querySelectorAll('.faq__question-btn,.collapsible-trigger[aria-controls]').forEach(el=>{
      if(el.closest('.np-header,.site-header,.np-mobile-drawer'))return;
      clearAccordionIcon(el);
      el.classList.add('np-action-accordion');apply(el,'down');
    });
    document.querySelectorAll('[data-add-to-cart]').forEach(el=>{
      if(!el.querySelector('.np-action-icon--cart,.icon-cart'))el.prepend(svg('cart'));
    });
  }
  let scheduled=false;
  const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;update();});};
  update();
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['href','target','aria-expanded']});
  document.addEventListener('shopify:section:load',schedule);
})();